import React from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import Benefits from './components/Benefits';
import Technologies from './components/Technologies';
import CaseStudies from './components/CaseStudies';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Solutions />
      <Benefits />
      <Technologies />
      <CaseStudies />
      <Team />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
